
import { ref } from '@vue/composition-api'
import { DashboardService } from './services'

import { reFormatDevicesData, reformatCatsData, reFormatGardenData } from './dataFormater'

import store from '@/store'
import { useRouter } from '@core/utils/utils'


const checkPeriodAndDate=(responseperiod ,resoponseDate)=>{
   let store_period=store.state.dashBoardFilter.current_period
   let store_date=store.state.dashBoardFilter.date;
   let vaild=false;
if(store_date=="" && store_period==responseperiod ){
   vaild=true
}
let resDate=resoponseDate.split(' ') [0]    
if(store_date==resDate  && store_period==responseperiod ){
   vaild=true
}




   return vaild;

}

const periodTimeOutCalculater =function(period_name){
   let time_out=10*3000;
  
   switch(period_name){
      
      case 'daily':
         time_out=     30 * 1000;
     break;
     case 'weekley':
      time_out=  60*1000;
      break;
      case 'monthly':
         time_out= 120*1000;
      break;
      case 'quarterly':
         time_out=10*3000*60;
       break;
       case 'yearly':
         time_out=10*3000*120;
         break;  

   }
   return time_out;

}

export default function DashBoardData() {
   let all_promices = []
  
   const { route, router } = useRouter()
   let datafilter_store =
      store.state.dashBoardFilter !== undefined &&
         store.state.dashBoardFilter.filterData !== undefined ? store.state.dashBoardFilter.filterData : undefined;

   // let datafilter_store =store.state.dashBoardFilter.filterData;
   const widgets = store.state.auth.userData.widgets
   //DevicesData
   const devices_data = ref({ loading: false, isCompleteRequest: false, data: {status:[], day:[]}, total:0})
   const categories_data = ref({ loading: false, data: [] })
   ////////////services //////////////
   const sweep_data = ref({ loading: false, isCompleteRequest: false, data: { Contracts:{ series:[], lists:[], categories:[]}}})
   const rain_data = ref({ loading: false, isCompleteRequest: false, data: {} })
   const wash_data = ref({ loading: false, isCompleteRequest: false, data: { Contracts:{ series:[], lists:[], categories:[]}}})
   const container_data = ref({ loading: false, isCompleteRequest: false, data: {Total:0, Dumped:0, NotDumped:0} })
   const dump_by_stops_data = ref({ loading: false, isCompleteRequest: false, data: { Contracts:{ series:[], lists:[], categories:[]}}})
   const dump_by_reader_data = ref({ loading: false, isCompleteRequest: false, data: { Contracts:{ series:[], lists:[], categories:[]}}})
   const garden_data = ref({
      loading: false, isCompleteRequest: false, data: {
         lseries_data: [],
         labels_data: [],
         other_info: [],

      }
   })
  // ServiceSummary///
  const summary_data=ref({laoding:false,isCompleteRequest:false,data:{}})


   const irrigation_data = ref({
      loading: false, isCompleteRequest: false, data: {
         lseries_data: [],
         labels_data: [],
         other_info: []
      }
   })
////////////services End //////////////

   /////////  Regions //////
   const geofences_data = ref({ loading: false, data: {} })
   //////// Regions End /////
   const currentTabe = ref("Devices")
   devices_data.value.isCompleteRequest = false;
   /////////////

 

   const summaryService = (filterData, isFirstRelaod) => {
      let current_period=store.state.dashBoardFilter.current_period
      let store_date=store.state.dashBoardFilter.date;
      
     return new Promise((resolve, reject) => {

        let summeryParams = { type: "ServiceSummary" };
        
        if (filterData !== undefined) {
           Object.assign(summeryParams, {...store.getters['dashBoardFilter/getFilterData'], period:current_period})
        }
      //   if(current_period!== undefined){
      //      Object.assign(rainParams,{period:current_period})
      //   }
      //   if(store_date!== undefined  && store_date!=""){
      //      Object.assign(rainParams,{date:store_date})
      //   }

          summary_data.value.loading = isFirstRelaod;
        DashboardService.getWidgetData(summeryParams).then(res => {
          
           if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
            summary_data.value.data = res.data
            summary_data.value.loading = false;
           }
          
        }).catch(reason => reason.status === 422).finally(() => { 
          // rain_data.value.loading = false;
         })

     });

  }

   const rainservice = (filterData, isFirstRelaod) => {
       let current_period=store.state.dashBoardFilter.current_period
       let store_date=store.state.dashBoardFilter.date;
       
      return new Promise((resolve, reject) => {

         let rainParams = { type: "Rain" };
         
         if (filterData !== undefined) {
            Object.assign(rainParams, store.getters['dashBoardFilter/getFilterData'])
         }
         if(current_period!== undefined){
            Object.assign(rainParams,{period:current_period})
         }
         if(store_date!== undefined  && store_date!=""){
            Object.assign(rainParams,{date:store_date})
         }

         rain_data.value.loading = isFirstRelaod;
         DashboardService.getWidgetData(rainParams).then(res => {
           
            if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
               rain_data.value.data = res.data
               rain_data.value.loading = false;
            }
           
         }).catch(reason => reason.status === 422).finally(() => { 
           // rain_data.value.loading = false;
          })

      });

   }








   const sweepService = (filterData, isFirstRelaod) => {
      let current_period=store.state.dashBoardFilter.current_period
      let store_date=store.state.dashBoardFilter.date;
      return new Promise((resolve, reject) => {
         let sweepParams = { type: "Sweep" };
         if (filterData !== undefined) { Object.assign(sweepParams, filterData) }
         sweep_data.value.loading = isFirstRelaod;

         if(current_period!== undefined){Object.assign(sweepParams,{period:current_period}) }
         if(store_date!== undefined  && store_date!=""){Object.assign(sweepParams,{date:store_date})}

         DashboardService.getWidgetData(sweepParams).then(res => {
            if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
            sweep_data.value.data = res.data
            sweep_data.value.loading = false;
            resolve(res)
            }
         })

      });


   }

   const washService = (filterData, isFirstRelaod) => {
      let current_period=store.state.dashBoardFilter.current_period
      let store_date=store.state.dashBoardFilter.date
      return new Promise((resolve, reject) => {
         let washParams = { type: "Wash" };
         if (filterData != undefined) {
            Object.assign(washParams, filterData)
         }
         if(current_period!== undefined){
            Object.assign(washParams,{period:current_period})
         }
         if(store_date!== undefined  && store_date!=""){Object.assign(washParams,{date:store_date})}
         wash_data.value.loading = isFirstRelaod;
         DashboardService.getWidgetData(washParams).then(res => {
            if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
            wash_data.value.data = res.data
            wash_data.value.loading = false;
            resolve(res)
            }

         });
      });




   }


   const containerService = (filterData, isFirstRelaod) => {
      let current_period=store.state.dashBoardFilter.current_period
      let store_date=store.state.dashBoardFilter.date;
      return new Promise((resolve, reject) => {
         let containersParams = { type: "Containers" };
         if (filterData != undefined) {
            Object.assign(containersParams, filterData)
         }
         if(current_period!== undefined){
            Object.assign(containersParams,{period:current_period})
         }
         if(store_date!== undefined  && store_date!=""){Object.assign(containersParams,{date:store_date})}
         container_data.value.loading = isFirstRelaod;
         DashboardService.getWidgetData(containersParams).then(res => {
            container_data.value.data = res.data
            container_data.value.loading = false;
            resolve(res)
         })


      });

   }

   const dumpByStopsService = (filterData, isFirstRelaod) => {
      let current_period = store.state.dashBoardFilter.current_period
      let store_date = store.state.dashBoardFilter.date;
      return new Promise((resolve, reject) => {
         let params = { type: "DumpByStops" };
         if (filterData != undefined) {
            Object.assign(params, filterData)
         }
         if(current_period !== undefined){
            Object.assign(params, {period:current_period})
         }
         if(store_date !== undefined  && store_date != ""){Object.assign(params,{date:store_date})}
         dump_by_stops_data.value.loading = isFirstRelaod;
         DashboardService.getWidgetData(params).then(res => {
            if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
               dump_by_stops_data.value.data = res.data
               dump_by_stops_data.value.loading = false;
            }
            resolve(res)
         })


      });

   }

   const dumpByReaderService = (filterData, isFirstRelaod) => {
      let current_period = store.state.dashBoardFilter.current_period
      let store_date = store.state.dashBoardFilter.date;
      return new Promise((resolve, reject) => {
         let params = { type: "DumpByReader" };
         if (filterData != undefined) {
            Object.assign(params, filterData)
         }
         if(current_period !== undefined){
            Object.assign(params, {period:current_period})
         }
         if(store_date !== undefined  && store_date != ""){Object.assign(params,{date:store_date})}
         dump_by_reader_data.value.loading = isFirstRelaod;
         DashboardService.getWidgetData(params).then(res => {
            if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
               dump_by_reader_data.value.data = res.data
               dump_by_reader_data.value.loading = false;
            }
            resolve(res)
         })


      });

   }

   const gardenService = (filterData, isFirstRelaod) => {
      let current_period=store.state.dashBoardFilter.current_period
      let store_date=store.state.dashBoardFilter.date;
      garden_data.value.loading = isFirstRelaod;
      irrigation_data.value.loading = isFirstRelaod;
      let GardenParams = { type: "Garden" };
      if (filterData !== undefined) {
         Object.assign(GardenParams, filterData)
      }
      if(current_period!== undefined){
         Object.assign(GardenParams,{period:current_period})
      }
      if(store_date!== undefined  && store_date!=""){Object.assign(GardenParams,{date:store_date})}
      DashboardService.getWidgetData(GardenParams).then(res => {
         if(checkPeriodAndDate(res.data.PeriodInfo.name,res.data.PeriodInfo.start)){
          
         // const gatdenFormatedData = reFormatGardenData(res.data.GardenServiceChart);
         // const irrigationFormatedData = reFormatGardenData(res.data.IrrigationContracts);
         garden_data.value.loading = false;
         garden_data.value.data = res.data.Contracts;
         garden_data.value.other_info = [{ 'GardenServicePlanned': res.data.Planned, 'GardenServiceServed': res.data.Served ,"GardenServiceCompletion":res.data.completion}]
         }
         //garden_data.garden_list=gatdenFormatedData.listOfGardens


      })

   }






   const getAllPromices = (filterData, isFirstRelaod, isManualFilter) => {
      let promices = [];
       if(true){
         promices.push(summaryService(filterData, isFirstRelaod, isManualFilter))
       }
      if (widgets.includes('Rain')) {
         promices.push(rainservice(filterData, isFirstRelaod, isManualFilter))
      }
      if (widgets.includes('Sweep')) {
         promices.push(sweepService(filterData, isFirstRelaod))
      }
      if (widgets.includes('Wash')) {
         promices.push(washService(filterData, isFirstRelaod,))
      }

      if (widgets.includes('Containers')) {
         promices.push(containerService(filterData, isFirstRelaod))

      }

      if (widgets.includes('DumpByStops')) {
         promices.push(dumpByStopsService(filterData, isFirstRelaod))
      }

      if (widgets.includes('DumpByReader')) {
         promices.push(dumpByReaderService(filterData, isFirstRelaod))
      }

      if (widgets.includes('Garden')) {
         promices.push(gardenService(filterData, isFirstRelaod))

      }
      // console.log('all  widgets ',widgets)
      return promices;
   }

   const DevicesData = (filterData, isFirstRelaod) => {
      devices_data.value.loading = isFirstRelaod;
      let params = { type: "Devices" };
      if (filterData !== undefined) {
         Object.assign(params, filterData)
      }
      //{ type: "Devices" }


      DashboardService.getWidgetData(params)
         .then(res => {
            devices_data.value.data = reFormatDevicesData(res.data)
            devices_data.value.total = res.data.Total.count
            devices_data.value.loading = false;
            categories_data.value.loading = false;
            devices_data.value.isCompleteRequest = true;
            //   console.log(res.data.Categories)
            categories_data.value.data = reformatCatsData(res.data.Categories);
            //  if(res.status==200 &&  store.state.dashBoardFilter!==undefined){       

            setTimeout(
               function () {
                  if (store.state.dashBoardFilter != undefined) {
                     if (store.getters['dashBoardFilter/getCurrentTab'] == "" || store.getters['dashBoardFilter/getCurrentTab'] == "Devices") {
                        if (store.state.dashBoardFilter.windowFoucs == true) { DevicesData(store.getters['dashBoardFilter/getFilterData'], false) }
                     }

                  }

               }
               , 10 * 3000);
            // }


         })
         .catch(reason => { console.log(reason) })
         .finally(() => { devices_data.value.loading = false; })
   }



   const ServiceData = (filterData, isFirstRelaod) => {
      let current_period=store.state.dashBoardFilter.current_period
      Promise.allSettled([
         getAllPromices(filterData, isFirstRelaod)
      ]).then((results) => {
         
         setTimeout(function () {
            if (store.state.dashBoardFilter !== undefined) {
               if (store.getters['dashBoardFilter/getCurrentTab'] == "" || store.getters['dashBoardFilter/getCurrentTab'] == "Services") {
                  if (store.state.dashBoardFilter.windowFoucs == true) { 

                     ServiceData(store.getters['dashBoardFilter/getFilterData'], false)
                   }
               }

            }

         },
         periodTimeOutCalculater(current_period))


      })
         .catch((error) => {
            console.error(error.message)
         });;





   }

   const RegionData = (filterData, isFirstRelaod, isManualFilter) => {

      if (widgets.includes('Geofences')) {


         let GeofencesParams = { type: "Geofences" };
         if (filterData !== undefined) {
            Object.assign(GeofencesParams, filterData)
         }
         geofences_data.value.loading = isFirstRelaod;
         DashboardService.getWidgetData(GeofencesParams).then(res => {
            geofences_data.value.data = res.data
            geofences_data.value.loading = false;


            // if(res.status==200 &&  store.state.dashBoardFilter!==undefined){

            setTimeout(

               function () {
                  if (store.state.dashBoardFilter !== undefined) {
                     if (store.getters['dashBoardFilter/getCurrentTab'] == "" || store.getters['dashBoardFilter/getCurrentTab'] == "Regions") {
                        if (store.state.dashBoardFilter.windowFoucs == true) { RegionData(store.getters['dashBoardFilter/getFilterData'], false) }
                     }
                  }
               }

               , 10 * 3000);
            // }
         }).catch(reason => { console.log(reason) }).finally(() => {

            geofences_data.value.loading = false;
         })

      }
      //}


   }


   return {
      devices_data,
      categories_data,
      currentTabe,
      sweep_data,
      rain_data,
      wash_data,
      summary_data,
      container_data,
      dump_by_stops_data,
      dump_by_reader_data,
      garden_data,
      irrigation_data,
      geofences_data,
      DevicesData,
      ServiceData,
      RegionData,



   }



}







